<template>
    <div class="home">
        <div class="title">
            <img class="title_image" src="@/assets/images/title.png" alt />
        </div>
        <div class="home-content">
            <div class="policy">
                <div class="contain">
                    <div class="policy_list">
                        <div class="policy_item" @click="togglePage('policeInfo')">
                            <span>
                                {{
                                    pilicyList.length > 0 ? pilicyList[index].classify2Name + ":" : ""
                                }}
                            </span>&nbsp;
                            <span>
                                {{
                                    pilicyList.length > 0 ? pilicyList[index].title : ""
                                }}
                            </span>
                        </div>
                    </div>
                </div>
                <div class="logo" @click="togglePage('policeInfo')">
                    <img src="@/assets/images/police_logo.png" alt />
                </div>
            </div>
            <div class="service">
                <div class="top">
                    <p>申请服务</p>
                    <!-- <div class="right" @click="togglePage('applicationRecord')">
                        <div class="icon"></div>
                        <div class="word">申请记录</div>
                    </div> -->
                </div>
                <div class="item">
                    <van-grid>
                        <van-grid-item @click="togglePage('serviceDetail', item)" v-for="item in governmentServiceList"
                            :key="item.id">
                            <img :src="item.serviceThumbnail[1].imgUrl | transImgUrl" alt
                                v-if="item.serviceThumbnail && item.serviceThumbnail[1]" />
                            <img src="@/assets/images/shower.png" alt v-else />
                        </van-grid-item>
                    </van-grid>
                </div>
                <div class="adviser">
                    <img src="@/assets/images/adviser.png" alt />
                    <div class="round" @click="togglePage('careConsultant')">
                        <img src="@/assets/images/pointer.png" alt />
                    </div>
                </div>
            </div>
            <div class="nav">
                <div class="nav-itemO" @click="goPages('weeklyMenu')">
                    <p>每周菜单</p>
                    <span>查看></span>
                    <img src="@/assets/images/Group3.png" alt="">
                </div>
                <div class="nav-itemT" @click="goPages('oldAgeActivity')">
                    <p>老年活动</p>
                    <span>查看></span>
                    <img src="@/assets/images/Group4.png" alt="">
                </div>
            </div>
            <!-- <div class="third_party">
            <div class="top">
                <div class="left">第三方服务</div>
                <div class="right" @click="thirdList">
                    更多
                    <van-icon name="arrow" />
                </div>
            </div>
            <div class="container">
                <div class="list">
                    <list-item
                        v-for="item in thirdPartyServiceList"
                        :item="item"
                        :key="item.id"
                        @click.native="togglePage('thirdDetail', item)"
                    ></list-item>
                </div>
            </div> 
        </div> -->
        </div>
    </div>
</template>

<script>
// eslint-disable-next-line no-unused-vars
import wx from "weixin-js-sdk";
import { mapMutations } from "vuex";
import { getPolicyList } from "@/api/home.js";
import { areaCode } from "@/common/constants.js";
import { getServiceList } from "@/api/service.js";
export default {
    name: "Home",
    components: {},
    data() {
        return {
            active: "home",
            pilicyList: [],
            change: 0,
            governmentServiceList: [],
            thirdPartyServiceList: [],
            index: 0
        };
    },
    mounted() {
        this.getPolicy();
        this.serviceList("p_government");
        this.serviceList("p_party ");
        setInterval(() => {
            this.index !== 4 ? (this.index += 1) : (this.index = 0);
        }, 5000);
    },
    methods: {
        togglePage(name, item = {}) {
            if (name == 'serviceDetail') {
                window.localStorage.setItem("serviceName", item.serviceName)
                window.localStorage.setItem("serviceId", item.id)
                this.$store.commit('service/setServiceName', item.serviceName)
                this.$store.commit('service/setServiceId', item.id)
            }
            if (name == "applicationRecord") {
                // 判断是否有登录，没有登录则跳转到登录页
                if (!window.localStorage.getItem("openId")) {
                    this.$router.push({
                        name: "login"
                    });
                    return;
                }
            }
            this.$router.push({
                name,
                query: {
                    id: item.id,
                    title: item.title,
                    serviceName: item.serviceName
                }
            });
        },
        thirdList() {
            this.$router.push("thirdList");
            this.toggleTab("service");
        },
        ...mapMutations("globel", [
            "toggleTab" // 将 `this.increase()` 映射为 `this.$store.commit('increase')`
        ]),
        async getPolicy() {
            const { data } = await getPolicyList({ areaCode });
            this.pilicyList = data.list;
        },
        async serviceList(serviceNature) {
            const { list } = await getServiceList({ areaCode, serviceNature });
            if (serviceNature === "p_government") {
                this.governmentServiceList = list;
            } else {
                this.thirdPartyServiceList = list;
            }
        },
        // 跳转对应页面
        goPages(val) {
            this.$router.push(val)
        }
    }
};
</script>

<style lang="scss">
.home {
    .title {
        padding: 0 20px;
        margin-bottom: 20px;
        background: linear-gradient(#fffefd, #DEDDDC);
        height: 144px;
        overflow: hidden;

        .title_image {
            width: 100%;
            background-color: #cce6ff;
            border-radius: 15px 15px 0 0;
        }
    }

    .home-content {
        background-color: #fffefd;
        padding: 0 20px;

        .policy {
            display: flex;
            height: 44px;
            justify-content: space-between;

            .contain {
                position: relative;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
                padding: 0 18px;
                width: 280px;
                box-shadow: 0px 2px 11px 0px rgba(72, 52, 4, 0.16);
                border-radius: 22px;

                .policy_list {

                    text-align: center;

                    .policy_item {
                        display: flex;
                        align-items: center;
                        height: 100%;
                        white-space: nowrap;
                        overflow: hidden;
                        text-overflow: ellipsis;
                    }
                }

                span:nth-of-type(1) {
                    font-size: 14px;
                    font-weight: 700;
                    line-height: 44px;
                }

                span:nth-of-type(2) {
                    font-size: 12px;
                    font-weight: 700;
                    line-height: 44px;
                }
            }

            .logo {
                width: 44px;
                border-radius: 50%;
                box-shadow: 2px 2px 50px #cccccc;
                display: flex;
                justify-content: center;
                align-items: center;

                img {
                    width: 14px;
                    height: 20px;
                }
            }
        }

        .service {
            margin-top: 30px;

            .top {
                display: flex;
                justify-content: space-between;

                p {
                    opacity: 0.9;
                    font-size: 18px;
                    font-family: PingFang SC, PingFang SC-Bold;
                    font-weight: 700;
                    text-align: center;
                    color: #222222;
                }

                .right {
                    display: flex;
                    align-items: center;

                    .icon {
                        width: 16px;
                        height: 16px;
                        background: url("~@/assets/images/clock.png");
                        // background-color: red;
                        background-size: contain;
                    }

                    .word {
                        margin-left: 10px;
                        opacity: 0.9;
                        font-size: 14px;
                        font-family: PingFang SC, PingFang SC-Bold;
                        font-weight: 700;
                        text-align: left;
                        color: #83889a;
                    }
                }
            }

            .item {
                width: 100%;
                overflow: auto;

                .van-grid {
                    &::after {
                        border-top-width: 0;
                    }

                    display: flex;
                    flex-wrap: nowrap;
                    justify-content: space-between;

                    .van-grid-item {
                        width: 110px;
                        position: relative;
                        margin-right: 5px;

                        .van-grid-item__content {
                            padding-left: 0;
                        }

                        .van-grid-item__content::after {
                            border-width: 0;
                        }

                        span {
                            position: absolute;
                            top: 90px;
                            width: 76px;
                            height: 16px;
                            font-size: 14px;
                            text-align: center;
                            white-space: nowrap;
                            overflow: hidden;
                            text-overflow: ellipsis;
                        }

                        img {
                            width: 110px;
                            height: 110px;
                        }
                    }
                }
            }

            .adviser {
                position: relative;

                img {
                    width: 100%;
                }

                .round {
                    position: absolute;
                    top: 18px;
                    right: 20px;
                    background-color: #a3dcff;
                    width: 50px;
                    height: 50px;
                    border-radius: 50%;
                    display: flex;
                    justify-content: center;
                    align-items: center;

                    img {
                        width: 21px;
                        height: 16px;
                    }
                }
            }
        }

        .third_party {
            .top {
                margin-bottom: 10px;
                display: flex;
                justify-content: space-between;
                align-items: center;

                .left {
                    opacity: 0.9;
                    font-size: 18px;
                    font-family: PingFang SC, PingFang SC-Bold;
                    font-weight: 700;
                    text-align: left;
                    color: #000000;
                }

                .right {
                    display: flex;
                    align-items: center;
                    opacity: 0.9;
                    font-size: 12px;
                    font-family: PingFang SC, PingFang SC-Bold;
                    font-weight: 700;
                    text-align: left;
                    color: #83889a;
                    line-height: 20px;
                }
            }

            .container {
                overflow: auto;

                .list {
                    display: flex;

                    .list_item {
                        padding-bottom: 10px;
                        border-bottom: 1px solid #ddd;

                        .van-card {
                            // padding-left: 0;
                            padding-right: 0;

                            .van-card__content {
                                width: 200px;
                                height: 34px;
                                opacity: 0.9;
                                font-size: 12px;
                                font-family: PingFang SC, PingFang SC-Bold;
                                font-weight: 700;
                                text-align: left;
                                color: #7a7a7a;
                                margin-left: 20px;
                                line-height: 16px;

                                .van-card__title {
                                    margin-bottom: 15px;
                                    font-size: 14px;
                                    font-weight: 700;
                                    color: #000;
                                }
                            }
                        }
                    }
                }
            }
        }

        .nav {
            margin-top: 20px;
            display: flex;
            align-items: center;
            justify-content: space-between;

            .nav-itemO,
            .nav-itemT {
                width: 164px;
                height: 110px;
                border-radius: 8px;
                position: relative;

                // padding: 14px 0 0 10px;
                img {
                    width: 62px;
                    height: 64px;
                    position: absolute;
                    right: 11px;
                    bottom: 8px;
                }

                p {
                    font-style: normal;
                    font-weight: 500;
                    font-size: 18px;
                    line-height: 21px;
                    padding: 20px 0 0 10px;
                }

                span {
                    margin-top: 10px;
                    font-weight: 400;
                    font-size: 12px;
                    display: inline-block;
                    width: 40px;
                    height: 20px;
                    text-align: center;
                    line-height: 20px;
                    border-radius: 10px;
                    margin-left: 10px;
                }
            }

            .nav-itemO {
                background: #FFF9F0;
                box-shadow: 0px 4px 4px rgba(163, 101, 24, 0.08);

                p {
                    color: #E68E22;
                    background: url("../../assets/images/Ellipse11.png") no-repeat 6px 12px;
                }

                span {
                    color: #E58E22;
                    border: 0.5px solid #E58E22;
                }
            }

            .nav-itemT {
                background: rgb(215, 245, 220);
                box-shadow: 0px 4px 4px rgba(163, 101, 24, 0.08);

                p {
                    color: #1C9045;
                    background: url("../../assets/images/Ellipse10.png") no-repeat 6px 12px;
                }

                span {
                    color: #1C9045;
                    border: 0.5px solid #1C9045;
                }
            }
        }
    }
}
</style>
